import React from 'react'
import { RouteComponentProps, useLocation, useParams } from 'react-router-dom'
import BackButton from '../../components/AppBackButton/BackButton'
import PersonalTestForm from '../../components/Forms/PersonalTestForm'
import { useQuery } from 'react-query'
import { getCities, getPersonalTests, getPersonalTestsPackages } from '../../moduls/personal-tests'
import { CityType, PersonalTestPackageType, PersonalTestType } from '../../services/types'
import Loader from '../../components/AppLoader/Loader'

function useUrlQuery() {
  return new URLSearchParams(useLocation().search)
}

const PersonalTestsDetail: React.FC<RouteComponentProps> = () => {
    const params = useParams<{ id: string }>();
    const q = useUrlQuery();
    const lessonClassId = q.get('courseId') ? q.get('courseId') : undefined;
    const termId = q.get('termId') ? Number(q.get('termId')) : undefined;

  const { id } = params
  const { data: courses = [], isFetched } = useQuery<PersonalTestType[]>(
    ['personal-tests', { id }],
    getPersonalTests
  )
  const { data: coursesPackages = [] } = useQuery<PersonalTestPackageType[]>(
    'personal-tests-packages',
    getPersonalTestsPackages,
    {
      staleTime: Infinity
    }
  )

  if (!isFetched) return <Loader />

  return (
    <div className="page-row">
      <BackButton />
      <div className="page-row">
        <h1 className="h-text-center h-mb-15">Přijímačky nanečisto</h1>
        <PersonalTestForm
          courses={courses}
          packages={coursesPackages}
          preselectLessonClassId={lessonClassId}
          preselectTermId={termId}
        />
      </div>
    </div>
  )
}

export default PersonalTestsDetail
